import script from "./ExtentBoundary.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExtentBoundary.vue?vue&type=script&lang=ts&setup=true"

import "./ExtentBoundary.vue?vue&type=style&index=0&id=5aea219f&lang=scss"

const __exports__ = script;

export default __exports__